<template>
  <v-row align="center">
    <v-col cols="4">
      <p class="text-capitalize text-body-1">{{ day }}</p>
    </v-col>
    <v-col cols="4" style="position: relative">
      <v-tooltip v-if="showApply" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            style="position: absolute;left: -40px;top: 50%;transform: translateY(-50%);"
            color="primary"
            @click="$emit('click:apply-to-all')"
            depressed
            dark
            fab
            icon
            v-bind="attrs"
            small
            v-on="on"
          >
            <v-icon>mdi-check-all</v-icon>
          </v-btn>
        </template>
        <span>Aplicar a todo</span>
      </v-tooltip>
      <v-menu
        ref="start_workday"
        v-model="timePickers.start_workday"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        max-width="350px"
        min-width="350px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="start_workday"
            label="Inicio"
            prepend-inner-icon="mdi-clock-time-four-outline"
            readonly
            filled
            rounded
            class="rounded-small"
            dense
            name="dia"
            color="blue-grey"
            v-bind="attrs"
            v-on="on"
            hide-details
          ></v-text-field>
        </template>
        <v-time-picker
          v-if="timePickers.start_workday"
          :value="start_workday"
          @input="(val) => $emit('start_workday:change', val)"
          @click:second="timePickers.start_workday = false"
          full-width
          use-seconds
        ></v-time-picker>
      </v-menu>
    </v-col>

    <v-col cols="4">
      <v-menu
        ref="end_workday"
        v-model="timePickers.end_workday"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        max-width="350px"
        min-width="350px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="end_workday"
            label="Fin"
            prepend-inner-icon="mdi-clock-time-four-outline"
            readonly
            filled
            rounded
            class="rounded-small"
            dense
            color="blue-grey"
            v-bind="attrs"
            v-on="on"
            hide-details
          ></v-text-field>
        </template>
        <v-time-picker
          v-if="timePickers.end_workday"
          :value="end_workday"
          :min="start_workday"
          @input="(val) => $emit('end_workday:change', val)"
          @click:second="timePickers.end_workday = false"
          full-width
          use-seconds
        ></v-time-picker>
      </v-menu>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    day: String,
    start_workday: String,
    end_workday: String,
    showApply: Boolean,
  },

  data: () => ({
    timePickers: {
      start_workday: false,
      end_workday: false,
    },
  }),
};
</script>

<style></style>
